/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Marker_Import_Error_ToastInputs */



/**
* | output |
* | --- |
* | "An error occurred while importing markers: {error}" |
*
* @param {Marker_Import_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_error_toast = /** @type {((inputs: Marker_Import_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Une erreur est survenue lors de l'importation des marqueurs : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Beim Importieren der Marker ist ein Fehler aufgetreten: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Si è verificato un errore durante l'importazione dei marcatori: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Произошла ошибка при импорте маркеров: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se produjo un error al importar marcadores: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入标记时发生错误：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`マーカーのインポート中にエラーが発生しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`मार्कर आयात करते समय एक त्रुटि हुई: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Ocorreu um erro ao importar os marcadores: ${i?.error}`)
	return /** @type {LocalizedString} */ (`An error occurred while importing markers: ${i?.error}`)
});